module.exports = __webpack_public_path__ + "static/media/klos-blank-anniversary.65c42516.png";